export interface ForgotpasswordStateInterface {
  message: any;
}

export const initForgotpasswordStateInterface: ForgotpasswordStateInterface = {
  message: null,
};
